import { apiClient, getToken, getOrgId, getUserId } from '@devd-client/api';
import { TeammenuResponse } from '../helpers/teammenu.types';

export const getTeammenu = (): Promise<any> =>
  apiClient(
    `/v2/team/${getOrgId()}/lite${
      /^\/contributors\/$/.test(window.location.pathname)
        ? `?employee=${window.location.pathname?.split('/')?.pop()}`
        : ''
    }`,
    {
      method: 'GET',
      headers: {
        authorization: `bearer ${getToken()}`,
      },
    }
  );

export const postFavTeam = (params: any) => {
  return apiClient(`/v1/user/${getUserId()}/preference/team`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify(params),
  });
};

export const deleteFavTeam = (params: any) => {
  return apiClient(`/v1/user/${getUserId()}/preference/team/${params.name}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
  });
};
